import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useIsCurrentUserPublic } from "..";
import { useCurrentClubHasVisibleLessons_session$key } from "./__generated__/useCurrentClubHasVisibleLessons_session.graphql";

export const useCurrentClubHasVisibleLessons = (
  sessionRef: useCurrentClubHasVisibleLessons_session$key | null
) => {
  const session = useFragment(
    useCurrentClubHasVisibleLessonsFragmentString,
    sessionRef
  );

  const isCurrentUserPublic = useIsCurrentUserPublic(session ?? null);

  const enabledDepartments =
    session?.currentClientProfile?.member?.club?.departments?.edges?.flatMap(
      (e) => (e?.node && e.node.anyFacilityLessonsEnabled ? [e.node] : [])
    );

  return (
    enabledDepartments?.some((d) => {
      return d?.facilities?.edges?.some((e) => {
        if (!e?.node) return false;
        return (
          e?.node.isLessonsEnabled &&
          (isCurrentUserPublic
            ? e?.node.publicLessonsPermissionSet?.patronAccess !== "NONE"
            : e?.node.privateLessonsPermissionSet?.patronAccess !== "NONE")
        );
      });
    }) ?? false
  );
};

const useCurrentClubHasVisibleLessonsFragmentString = graphql`
  fragment useCurrentClubHasVisibleLessons_session on Session {
    ...useIsCurrentUserPublic_session
    currentClientProfile {
      member {
        club {
          departments {
            edges {
              node {
                anyFacilityLessonsEnabled
                facilities {
                  edges {
                    node {
                      isLessonsEnabled
                      publicLessonsPermissionSet {
                        patronAccess
                      }
                      privateLessonsPermissionSet {
                        patronAccess
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
